// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jWj_OcYqkg_bJs {
  display: flex;
  flex-flow: row;
  flex-wrap: wrap;
}
.O9Tt9xY_dLsTPk {
  display: flex;
  justify-content: center;
}
.acJqZZRHZrPqDN {
  flex: 1 1 auto;
  min-height: calc(100vh - 80px);
  padding-bottom: 32px;
  background-color: var(--ds-background-accent-gray-subtlest, #f1f2f4);
}
.r3QZ1E4prRAC06 {
  display: flex;
  justify-content: center;
  padding: 32px;
}
.JZ0wzwAbr0JkvL {
  font-style: italic;
}
.TUcYWl8r_j8_Dz {
  flex-grow: 1;
  min-width: 320px;
  max-width: 800px;
  padding: 32px;
  border: 1px solid var(--ds-border, #091e4224);
  border-radius: 4px;
  background-color: var(--ds-surface, #ffffff);
}
.DhAFmg4OFIyjs2 {
  display: flex;
  align-items: center;
  justify-content: center;
}
.d3xEDuvw0eiO7t {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--ds-border, #091e4224);
}
.d3xEDuvw0eiO7t .vWDh6n_SYicyuR {
  margin: 12px 0 0;
}
.tzMKa3gCLlRV0Q {
  padding-top: 16px;
  border-top: 1px solid var(--ds-border, #091e4224);
}
.tzMKa3gCLlRV0Q button {
  margin-left: 8px;
}
.lsiA8ciIiaKyWi {
  display: flex;
  justify-content: flex-end;
}
@media only screen and (max-width: 900px) {
  .TUcYWl8r_j8_Dz {
    padding: 16px;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flexRowWrap": `jWj_OcYqkg_bJs`,
	"flexAndCenter": `O9Tt9xY_dLsTPk`,
	"body": `acJqZZRHZrPqDN`,
	"navigationAndContent": `r3QZ1E4prRAC06`,
	"learnMoreSubtle": `JZ0wzwAbr0JkvL`,
	"content": `TUcYWl8r_j8_Dz`,
	"spinnerContainer": `DhAFmg4OFIyjs2`,
	"header": `d3xEDuvw0eiO7t`,
	"title": `vWDh6n_SYicyuR`,
	"footer": `tzMKa3gCLlRV0Q`,
	"formFooter": `lsiA8ciIiaKyWi`
};
export default ___CSS_LOADER_EXPORT___;
